import Http from '../API'

const select_options = {
    state: {
        reports: { formats: [], defaults: {}, metrics: {} },
        blocked_simcard_reasons: [],

        client_edo_systems: [],

        client_invoices:{
            payment_statuses: [],
            types: [],
            validation_statuses: []
        },

        client_order_specs: {
            statuses: [],
            types : [],
            list: []
        },

        client_orders: {
            statuses: [],
            types : []
        },

        client_requests: {
            statuses: [],
            types : []
        },

        comments_filter: {},

        device_models: [],

        device_skus: [],

        projects:{
            prioritys: [],
            statuses: [],
            visibility_type: []
        },

        simcards:{
            blocked_reasons: [],
            mno: [],
            operator_apn: [],
            profile: []
        },

        snapshots:{
            statuses: [],
        },

        storage_list:{
            statuses: [],
            defects: [],
        },

        support: {
            statuses: {},
            topics: []
        },

        tariff_services: [],
        diadoc_documents: {
            categories: [],
            statuses: []
        },

        sim_tasks:{
            actions: [],
            statuses: [],
            results: []
        }
    },
    getters: {
        getReportsOptions: (state) => state.reports,
        getClientEdoSystems: (state) =>{
            return state.client_edo_systems
        },
        getClientInvoicesInfo: (state) =>{
            return state.client_invoices
        },
        getClientOrderSpecs: (state) => {
            return state.client_order_specs
        },
        getClientOrdersInfo: (state) =>{
            return state.client_orders
        },
        getClientRequestsInfo: (state) =>{
            return state.client_requests
        },
        getCommentsFilter: (state) => {
            return state.comments_filter
        },
        getDeviceModels: (state) =>{
            return state.device_models
        },
        getDeviceSkus (state) {
            return state.device_skus
        },
        getProjectInfo: (state) =>{
            return state.projects
        },
        getBlockedSimcardReason: (state) =>{
            return state.simcards.blocked_reasons
        },
        getSimcardMno: (state) =>{
            return state.simcards.mno
        },
        getSimcardOperatorApn: (state) =>{
            return state.simcards.operator_apn
        },
        getSimcardProfileStatuses: (state) =>{
            return state.simcards.profile
        },
        getSimcardProfileStatusesById: (state) => (status_id) =>{
            const new_status = state.simcards.profile.find(status => {
                if (status.id === status_id) return status
            })
            return new_status ? new_status : {}
        },
        getSnapshotsInfo: (state) =>{
            return state.snapshots
        },
        getStorageListInfo: (state) =>{
            return state.storage_list
        },
        getTariffServices: (state) =>{
            return state.tariff_services
        },
        getSupportInfo: (state) =>{
            return state.support
        },
        getDiadocDocument: (state) =>{
            return state.diadoc_documents
        },
        getSimTasks: (state) =>{
            return state.sim_tasks
        },
    },
    mutations: {
        userSelectOptions (state, new_options) {
            Object.keys(new_options).forEach((key) => {
                state[key] = new_options[key]
            })
        },
    },
    actions: {
        async userSelectOptions () {
            await Http.v1.getUserSelectOptions((response) => {
                this.commit('userSelectOptions', response.data)
                this.commit('donePreloadName', 'userSelectOptions')
            })
        },
    }
}
export default select_options
